export default __webpack_public_path__ + "static/media/gallery_09.914e0f14.jpg";